<ng-template #imeiLockingModalFormContent role="document" let-modal>

  @if(!embeddedFormMode) {
    <app-modal-comp-header
      [title]="formTitle"
      (cancelButtonOnClick)="closeForm(); modal.dismiss('Cross click')"
    ></app-modal-comp-header>
  }

  <div class="row">
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
    <div [className]="embeddedFormMode ? 'col-6' : 'col-0'">

    <form (ngSubmit)="saveFormData()" [formGroup]="imeilockingForm" class="tablelist-form" autocomplete="off" name="no-autofill-form">
      <div class="modal-body">

        <!-- <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <div class="alert alert-progress-info d-flex align-items-center mb-0" [ngClass]="alertColourProgress" role="alert">
                <i class="alert-progress-info__icon me-2" [ngClass]="alertColourProgress=='alert-danger' ? 'ri-error-warning-fill' : 'ri-information-fill'"></i>
                <span [innerHtml]="progressInformation"></span>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
          <div class="col-12 mb-3">
            <div class="btn-group" role="group" aria-label="Basic radio toggle button group">
              @if (existingImeiLock != "") {
                <input type="radio" class="btn-check" name="imeiRadio" id="imeiremoveradio"
                       formControlName="imeiRadio" [value]="'remove'" (change)="onRadioChange('remove')">
                <label class="btn btn-outline-danger mb-0" for="imeiremoveradio">Remove Lock</label>
              }
              @if (existingImeiLock != this.existingImei) {
                <input type="radio" class="btn-check" name="imeiRadio" id="imeiexistingradio"
                       formControlName="imeiRadio" [value]="'existing'" (change)="onRadioChange('existing')">
                <label class="btn btn-outline-success mb-0" for="imeiexistingradio">Lock to existing IMEI ({{this.existingImei}})</label>
              }
              <input type="radio" class="btn-check" name="imeiRadio" id="imeireplacementradio"
                     formControlName="imeiRadio" [value]="'specify'" (change)="onRadioChange('specify')">
              <label class="btn btn-outline-success mb-0" for="imeireplacementradio">Specify IMEI</label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="imeilock-field" class="form-label text-right">IMEI Lock</label>
              <input #imeilockfield
                autocomplete="off"
                class="form-control text-end"
                [ngClass]="{ 'is-invalid': formSubmitted && formData['imeilock'].errors }"
                data-lpignore="true"
                formControlName="imeilock"
                id="imeilock-field"
                [placeholder]="placeholderText"
                [readonly]="preventAutofill"
                (input)="validateImeiLockInput()"
                type="text"
                (mousedown)="preventAutofill=false; ($any($event.target)).readOnly=false; ($any($event.target)).focus()"
              />
              @if(formData["imeilock"].hasError("minlength")) {
                <div class="invalid-feedback">IMEI Lock must be at least 14 digits in length</div>
              } @else if(formData["imeilock"].hasError("maxlength")) {
                <div class="invalid-feedback">IMEI Lock length is restricted 100 </div>
              } @else if(formData["imeilock"].hasError("pattern")) {
                <div class="invalid-feedback">IMEI Lock must contain number characters only</div>
              } @else {
                <div class="invalid-feedback">A value is required</div>
              }
            </div>
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-center">
              @if(this.imeilockingInProgress) {
                <lord-icon
                  colors="primary:#121331,secondary:#08a88a"
                  src="https://cdn.lordicon.com/kbtmbyzy.json"
                  style="width: 75px; height: 75px;"
                  trigger="loop"
                ></lord-icon>
              }
            </div>
          </div>
        </div>

        <div class="col-12">
          <div class="hstack gap-2 justify-content-end">
            @if(!embeddedFormMode) {
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="closeForm();modal.close('Close click')">Close</button>
            }
            <button type="submit" [ngClass]="{ 'btn' : true, 'btn-danger' : this.imeilockingButtonText == 'Remove Lock', 'btn-success' : this.imeilockingButtonText != 'Remove Lock' }" id="add-btn" [disabled]="!imeilockingButtonEnabled">{{ imeilockingButtonText }}</button>
          </div>
        </div>
      </div>
    </form>
    </div>
    <div [className]="embeddedFormMode ? 'col-3' : 'col-0'"></div>
  </div>
</ng-template>

 
<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>
 
<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
